import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/app/")({
  beforeLoad: () => {
    throw redirect({
      to: "/app/dashboard",
    });
  },
  component: Outlet,
});
